import { StandardProps } from "@/components/componentMap";
import styles from "./EnergyLabelAndSaving.module.scss";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { EnergyLabel } from "./components/EnergyLabel/EnergyLabel";
import { EnergySaving } from "./components/EnergySaving/EnergySaving";
import { useYourekoEnergySaving } from "./useYourekoEnergySaving";

export function EnergyLabelAndSaving({
  flags,
  product,
  configProps,
}: Pick<StandardProps, "product" | "flags" | "configProps">) {
  const shouldShowEnergySaving = configProps?.showEnergySaving !== false;
  const { variant } = useVariant(product);
  const energy = variant.energy;
  const { result, refetch, isLoading, isDisabled } = useYourekoEnergySaving({
    sellingProductType: shouldShowEnergySaving
      ? product.sellingProductType
      : undefined,
    variantTitle: variant.title,
  });

  const isEnergySavingVisible =
    shouldShowEnergySaving &&
    !isLoading &&
    !isDisabled &&
    result?.canButtonBeShown === true;

  if (!energy && !isEnergySavingVisible) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.energyLabelWrapper}>
        {energy && (
          <EnergyLabel
            informationSheet={energy.informationSheet || undefined}
            isLegacy={!!energy.rating.legacy}
            label={energy.label || undefined}
            rating={energy.rating.value}
            openDrawerEvent={String(flags.energyLabelOnOpenDrawerEvent.value)}
            closeDrawerEvent={String(flags.energyLabelOnCloseDrawerEvent.value)}
          />
        )}
      </div>
      {isEnergySavingVisible && result && (
        <EnergySaving
          energyCostSavingUnformatted={result.energyCostSavingUnformatted}
          numberOfAlternatives={result.numberOfAlternatives}
          medalRatingText={result.medalRatingText}
          refetch={refetch}
        />
      )}
    </div>
  );
}
